module.exports = __webpack_public_path__ + "static/media/octorion-add-laplop.d1407aae.svg";